module.exports = __webpack_public_path__ + "static/carreiras-1a48fb96a118efef032f65d9e291ca0b.png";